/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import UI from "@mile-meeting/mile-ui";
import Modal from "react-modal";

const modalStyle = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    border: "none",
    background: "transparent",
    transform: "translate(-50%, -50%)",
  },
  overlay: {
    backgroundColor: "var(--component-color-material-dimmer)",
    zIndex: 1000,
  },
};
Modal.setAppElement("#root");

type Props = {
  modalIsOpen: boolean;
  closeModal: () => void;
  onChange?: () => void;
  title?: string | JSX.Element;
  content?: JSX.Element | string;
  btnTitle?: string;
  zIndex?: number;
};

export default function AlertModal(props: Props) {
  const { modalIsOpen, closeModal, onChange, title, content, btnTitle, zIndex = 1000 } = props;

  return (
    <Modal
      isOpen={modalIsOpen}
      onRequestClose={closeModal}
      style={{ ...modalStyle, overlay: { zIndex: zIndex, backgroundColor: "var(--component-color-material-dimmer)" } }}
    >
      <UI.CautionModal
        onClose={closeModal}
        description={content}
        title={title}
        btnLabel={btnTitle}
        onClickBtn={onChange}
      ></UI.CautionModal>
    </Modal>
  );
}
